<template>
  <div class="content" style="overflow-y: auto;">
    <div class="fl back-color-fff borderR6 left-tree-box">
      <el-input size="mini" placeholder="输入关键字搜索" v-model="filterText" style="width: 80%; margin-top:10px;" @change="getTagList(filterText)">
      </el-input>
      <el-button icon="el-icon-plus" class="add-btn" @click="addTag">添加标签</el-button>
     
      <el-table
        :data="tagList"
        class="mt15"
        ref="singleTable"
        highlight-current-row
        @row-click="handle"
        :show-header="false"
      >
      <el-table-column prop="categoryName">
          <template slot-scope="scope">
            <div v-show="!sh[scope.$index]" style="padding-left: 20px;width: 130px;"  >{{ scope.row.categoryName }}</div>
            <el-input v-show="sh[scope.$index]" v-model="scope.row.categoryName" placeholder="请输入内容"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="right" >
          <template slot-scope="scope">
            <!-- v-if="shbtn[scope.$index]" -->
            <div class="btn" style="padding-right: 20px;">
              <a
                v-show="sh[scope.$index]"
                @click="addSalesTerritory(scope.$index, scope.row.guid, scope.row.categoryName)"
                class="txt-color"
              >{{ scope.row.guid?"修改":"新增" }}</a>
              <a
                v-show="!sh[scope.$index]"
                class="txt-color"
                @click="upDataTag(scope.$index)"
              >编辑</a>
              <a style="padding-left: 5px;" class="txt-color-red" @click="delTag(scope.row.guid,scope.$index)">删除</a>
            </div>
          </template>
        </el-table-column>
        
      </el-table>
    </div>

    <div class="right-content-box">
      <div class="search-area">
        <el-row :gutter="24">
          <el-col :span="8"
            ><div class="search-area-div">评级指标</div>
            <el-input size="mini" v-model="indicateName" placeholder="请输入" class="ipt-sty" />
          </el-col>
          <el-col :span="8">
            <div class="search-area-div">状态</div>
            <el-select size="mini" v-model="bizState" placeholder="请选择" class="ipt-sty">
              <el-option v-for="item in status" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="8" class="search-btn-box">
            <el-button size="mini" type="info" @click="search">搜索</el-button>
            <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
          </el-col>
        </el-row>
      </div>

      <div class="back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px;'">

        <div class="button-area">
          <el-button  size="mini" type="info" @click="addFieldConfig">添加指标</el-button>
          <el-button  size="mini" type="default" @click="delIndicate(guids,2)">批量删除</el-button>
        </div>
        <el-table :data="tableData" stripe border :height="tableHeight" style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="60" header-align="center" align="center"
            fixed="left"></el-table-column>
          

          <el-table-column prop="indicateName" label="评级指标" header-align="center" align="left" min-width="160" >
            <template slot-scope="scope">{{ scope.row.indicateName }}</template>
          </el-table-column>
          <el-table-column prop="bizState" label="状态"  header-align="center" align="left" width="80">
            <template slot-scope="scope">{{ scope.row.bizState | bizStateFilter}}</template>
          </el-table-column>
          <el-table-column prop="indicateDesc"  label="描述" header-align="center" align="left" min-width="160">
            <template slot-scope="scope">{{scope.row.indicateDesc | "-"}}</template>
          </el-table-column>

          <el-table-column prop=" indicateType" label="指标类型" header-align="center" align="left" width="100">
            <template slot-scope="scope">{{ scope.row.indicateType | indicateTypeFilter }}</template>
          </el-table-column>
          
        
          <el-table-column prop="createTime" label="创建时间" header-align="center" align="left" width="140">
            <template slot-scope="scope">{{ scope.row.createTime | getDate }}</template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center" fixed="right" min-width="120">
            <template slot-scope="scope">
              
              <a class="txt-color" @click="editFieldConfig(scope.row)">编辑 | </a>
            
              <a style="padding-left: 5px;" class="txt-color-red" @click="delIndicate(scope.row.guid,1)"> 删除 </a>
              
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="pt pb back-color-fff content-pagination-box" background @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :page-sizes="[10, 100, 200]" :current-page="page.pageIndex"
        :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
      </el-pagination>
      </div>
      
    </div>
    
    <!-- //! 编辑弹框 -->
    <el-dialog
      :title="textTitle"
      top="5vh"
      custom-class="configure-fields"
      :visible.sync="visible"
      :close-on-click-modal="false"
    >
      <el-form label-width="120px" label-position="right" class="demo-ruleForm">
        <div class="title" style="padding-left: 20px"><span></span>指标信息</div>
        <div style="display: flex; margin-bottom: 10px;">
          <div class="fl flex1">
            <!-- 指标名称 -->
            <el-form-item >
              <span slot="label" style="color: red">*</span>
              <span slot="label" >指标名称： </span>
              <el-input class="fl w240" type="input" placeholder="请输入指标名称" v-model="configForm.indicateName" />
              
            </el-form-item>
            <el-form-item
            label="状态"
            class="field-radio"
            >
              <span slot="label" style="color: red">*</span>
              <span slot="label">状态：</span>
              <el-radio-group
                class="fl"
                v-model="configForm.bizState"
              >
                <el-radio label="Y">有效</el-radio>
                <el-radio label="N">无效</el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- 指标权重 -->
            <el-form-item>
              <span slot="label" style="color: red">*</span>
              <span slot="label" >指标权重(%)： </span>
              <el-input class="fl w240"  placeholder="请输入数字，≤100" v-model="configForm.indicateWeight" @input="configForm.indicateWeight=configForm.indicateWeight.replace(/[^0-9]/g,'')" @blur="indicateWeightCheck(configForm.indicateWeight)"/>
            </el-form-item>
        </div>
        <div class="fr flex1">
          
            <!-- 指标类型 -->
            <el-form-item>
              <span slot="label" style="color: red">*</span>
              <span slot="label">指标类型：</span>
              <el-select
                class="fl w240"
                filterable
                disabled
                v-model="configForm.indicateType"
                placeholder="请选择"
               
              >
                <el-option
                  v-for="item in indicateTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          
          
            <el-form-item class="field-radio">
              <span slot="label" style="color: red">*</span>
              <span slot="label">指标描述：</span>
              <el-input
                style="width: 240px"
                type="textarea"
                :rows="3"
                maxlength="50"
                placeholder="文本，请添加备注，限制50个字"
                v-model="configForm.indicateDesc"
              >
              </el-input>
            </el-form-item>
            
        </div>
        </div>
      </el-form>
      <el-form label-width="120px" label-position="right" class="demo-ruleForm">
       
        <div style="display: flex;justify-content: space-between;">
          <div class="title" style="padding-left: 20px"><span></span>打分信息</div>
          <el-button size="mini" type="info" @click="addDetail"> 添加打分标准</el-button>
        </div>
        <el-table :data="configForm.details" stripe class="detail-class" style="width: 80%;margin: auto;" >
          <!-- 序号 -->
          <el-table-column prop="orderNum" label="序号" header-align="center" align="left" width="60">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.orderNum"
                @input="scope.row.orderNum=scope.row.orderNum.replace(/[^0-9]/g,'')"
                size="mini"
                
              />
            </template>
          </el-table-column>
          <!-- 打分内容 -->
          <el-table-column prop="scoreContent" label="打分内容" header-align="left" align="left"  > 
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.scoreContent"
                size="mini"
              />
            </template>
          </el-table-column>
          <!-- 分值 -->
          <el-table-column prop="score" label="分值" header-align="left" align="left" width="80">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.score"
                size="mini"
                @input="scope.row.score=scope.row.score.replace(/[^0-9]/g,'')"
                @blur="scoreCheck(scope.row.score,scope.$index)"
              />
            </template>
          </el-table-column>
          <!-- 是否一票否决 -->
          <el-table-column prop="isVote" label="是否一票否决" header-align="left" align="left" width="160">
            <template slot-scope="scope">
              <el-select size="mini" v-model="scope.row.isVote" placeholder="请选择" class="ipt-sty" >
              <el-option v-for="item in getCodeListByKey('是否')" :key="item.value" :label="item.text" :value="item.value">
              </el-option>
            </el-select>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column label="操作" header-align="left" align="left" width="80">
            <template slot-scope="scope">
              <a style="padding-left: 5px;" class="txt-color-red" @click="delDetail(scope.$index)"> 删除 </a>
              
            </template>
          </el-table-column>

        </el-table>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" plain @click="visible = false">取 消</el-button>
        <el-button size="mini" type="info" v-if="isEdit" @click="addIndicate(1)">修 改</el-button>
        <el-button size="mini" type="info" v-else @click="addIndicate(2)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
 
  data() {
    return {
      tableHeight: window.innerHeight - 246,
      contentMainHeight: window.innerHeight - 236,
      loading: false,
      visible:false,
      guids:[],
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
      },
      tableData:[
      ],
      configForm:{
        indicateName: '',//指标名称
        indicateType: null,//指标类型
        bizState: '',//指标状态
        indicateDesc: '',//指标描述
        indicateWeight: '',//指标权重
        details:[]
      },
      tagList:[ ],//标签列表
      sh:[],
      filterText:'',//标签搜索
      tagflag:0,
      textTitle:'',
      gradeCategoryGuid:''	,//标签的guid
      isEdit:false,
      tenantGuid:null,
      tabIndex:0,
      // 状态
      status:[
      {
          value: 'Y',
          label: '有效',
        },
        {
          value: 'N',
          label: '无效',
        }
        
      ],
      // 指标类型
      indicateTypeList:[
      {
          value: 1,
          label: '定性指标',
        },
        {
          value: 2,
          label: '定量指标',
        }
        
      ],
      // 评级列表
      indicateList:[
        {
          indicateName:'',//评级指标
        }
      
      ],
      indicateName:'',//评级指标
      bizState:'',//指标状态
       
    }
  },
  filters:{
    indicateTypeFilter(val){
      if(!val)return "-"
      if(val==1){
        return '定性指标'
      }else if(val==2){
        return '定量指标'
      }
    },
    bizStateFilter(val){
      if(!val)return "-"
      if(val=='Y'){
        return '有效'
      }else if(val=='N'){
        return '无效'
      }
    }
  },
  mounted() {
    this.tenantGuid=localStorage.guid//企业唯一标识
    this.getTagList()
    // this.search()
    
  },
  methods: {
    // 获取标签
    getTagList(name){
      let that=this
      let req={
        pageIndex:1,
        categoryName:name||'',	
        pageSize:50,	
      }
      that.api.postJson(`/${serverConfig.msCustomerService}/data-grade/category/page-list`, req).then((res) => {
      if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
        that.tagList=res.data.data.records||[]
        console.log('that.tagList',that.tagList);
        // 默认选中第一个标签
        // this.$refs.singleTable.setCurrentRow(that.tagList[0]);
        if(that.tagList.length>0){
          this.gradeCategoryGuid=that.tagList[0].guid
          this.search()
        }
        
      } else {
        that.$message.error(res.data.msg);
        
      }
    });
    },
    // 添加标签
    addTag(){
      this.sh[this.tagList.length] = true;
      this.tagList.push({});
      // this.sh[0] = true;
      // this.tagList.unshift({});
    },
    // 点击编辑
    upDataTag(index) {
    let that = this;
    if(that.sh.length>0){
      // that.sh.findIndex(item=>{
      //   return item==true
      // })
      if(that.sh.indexOf(true)>-1){
        this.$message.error('请先保存正在编辑中的标签，再编辑其他标签！');
        return
      }
      
      
    }
    that.tabIndex=(index>that.tabIndex)?index:that.tabIndex
    if(that.tabIndex!=0){
      that.sh[that.tabIndex] = false;
    }
    if(that.sh.length>0){
      that.sh.forEach((item,idx)=>{
      that.sh[idx] = false
      
    })
    }
    that.sh[index] = true;
    that.$forceUpdate()
    console.log('sh',that.sh);
    
    },
  // 新增/修改标签
    addSalesTerritory(index, guid, name) {
    let that = this;
    let tenantGuid = that.tenantGuid; 
    
    if (guid) {
      // 修改
      let req = {
        tenantGuid,
        categoryName: name,
        guid,
      };
      that.api
        .put(`/${serverConfig.msCustomerService}/data-grade/category/update`, req)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            that.$message.success('修改成功！');
            that.sh[index] = false;
            that.getTagList();
          } else {
            that.$message.error(res.data.msg);
          }
        });
    } else {
      // 新增
      let req={
        tenantGuid,
        categoryName:name	
      }
      that.api.postJson(`/${serverConfig.msCustomerService}/data-grade/category/add`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          that.$message.success('保存成功！');
          that.sh[index] = false;
          that.getTagList();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    }
    },
    // 点击标签
    handle(row, column, event) {
    this.gradeCategoryGuid = row.guid;//标签的guid
    this.search()
  },
  // 删除标签
  delTag(guid,index){
    let that=this
    if(!guid){
      that
      .$confirm('删除后不可恢复，确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
      .then(() => {
        that.tagList.splice(index, 1)
      });
    }else{
      that
      .$confirm('删除后不可恢复，确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
      .then(() => {
        let guids=[guid]
    that.api
      .postJson(`/${serverConfig.msCustomerService}/data-grade/category/del`, guids)
      .then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          that.$message.success('删除成功！');
          that.getTagList()
          
        } else {
          that.$message.error(res.data.msg);
        }
      });
      });
    }
  },
  
  // 添加指标
  addIndicate(flg){
    let that = this;
    let tenantGuid = that.tenantGuid; 
    if (!this.configForm.indicateName) {
      this.$message.error('请填写指标名称');
      return;
    } 
    if (!this.configForm.indicateWeight) {
      this.$message.error('请填写指标权重');
      return;
    } 
    if (!this.configForm.indicateDesc) {
      this.$message.error('请填写指标描述');
      return;
    } 
    if(this.configForm.details.length&&this.configForm.details.length>0){
      try{
        this.configForm.details.forEach((item,index)=>{
          if(!item.orderNum){
            throw new Error('序号不能为空');
          }
          if(!item.scoreContent){
            throw new Error('打分内容不能为空');
          }
          if(!item.score&&item.score === ''){
            throw new Error('分值不能为空');
          }
          if(!item.isVote){
            throw new Error('是否一票否决不能为空');
          }
        })
      }catch(e){
        that.$message.error(e.message);
        return;
      }
      
    }
    if (flg==1) {
      // 修改
      let req = {
        tenantGuid,
        ...that.configForm
      };
      that.api
        .put(`/${serverConfig.msCustomerService}/data-grade/indicate/update`, req)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            that.$message.success('修改成功！');
            that.visible=false
            that.search();
          } else {
            that.$message.error(res.data.msg);
          }
        });
    } else {
      // 新增
      let req = {
        tenantGuid,
        ...that.configForm
      };
      
      that.api.postJson(`/${serverConfig.msCustomerService}/data-grade/indicate/add`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          that.$message.success('保存成功！');
          that.visible=false
          that.search();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    }
  },
  // 删除评级指标
  delIndicate(guid,flg){
    let that=this
    that
      .$confirm('删除后不可恢复，确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
      .then(() => {
        let guids=flg=='1'?[guid]:guid
    that.api
      .postJson(`/${serverConfig.msCustomerService}/data-grade/indicate/del`, guids)
      .then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          that.$message.success('删除成功！');
          this.search()
          
        } else {
          that.$message.error(res.data.msg);
        }
      });
      });
    
  },
  // 删除打分信息
  delDetail(index){
    let that = this;
    that
      .$confirm('删除后不可恢复，确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
      .then(() => {
        this.configForm.details.splice(index, 1);
      });
  },
  // 获取评级指标
    search(){
      let that=this
      that.loading=true
      that.tableData=[]
      let req={
        pageIndex:that.page.pageIndex	,
        pageSize:that.page.pageSize	,
        gradeCategoryGuid:that.gradeCategoryGuid?that.gradeCategoryGuid:that.tagList[0].guid	,//标签的guid// 默认选中第一个标签
        indicateName:that.indicateName||""	,//指标名称
        // indicateType	,//指标类型，1 定性指标；2 定量指标
        bizState:that.bizState||''	
      }
      that.api.postJson(`/${serverConfig.msCustomerService}/data-grade/indicate/page-list`, req).then((res) => {
      if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
        that.tableData=res.data.data.records
        that.page.totalPage=res.data.data.totalPages
        that.page.totalRows=res.data.data.totalRows
        that.loading=false
        console.log('that.tableData',that.tableData);
        
      } else {
        that.$message.error(res.data.msg);
        
      }})
    },
    // 清空搜索
    emptySearch(){
      this.indicateName=''	,//指标名称
      this.bizState=''
      this.search()
    },
    // 添加指标按钮弹窗
    addFieldConfig() {
      if(!this.gradeCategoryGuid){
        this.$message.error('请先添加标签')
        return;
      }
    this.visible = true;
    // this.currentIndex = '';
    this.isEdit = false;
    this.textTitle = '添加指标';
    this.configForm = {
      gradeCategoryGuid:this.gradeCategoryGuid,//大类标签唯一标识
      indicateName:'',//指标名称
      indicateType:1,//指标类型
      bizState:'Y',//指标状态
      indicateDesc:'',//指标描述
      indicateWeight:'',//指标权重
      details:[],//评级指标明细添加参数

    };
    },
    // 编辑指标按钮弹窗
    editFieldConfig(detail) {
    console.log(detail);
    // 先请求评级指标详情
    let that = this;
    
    let guid=detail.guid
    that.api
      .get(`/${serverConfig.msCustomerService}/data-grade/indicate/detail/${guid}`)
      .then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          that.configForm = res.data.data;
          that.visible = true;
          that.isEdit = true;
          that.textTitle = '编辑指标';
          console.log('that.configForm',that.configForm);
          
        } else {
          that.$message.error(res.data.msg);
        }
      });
    // this.visible = true;
    // // this.currentIndex = index;
    // this.isEdit = true;
    // this.textTitle = '编辑字段';
    // this.configForm = {
    //   gradeCategoryGuid:detail.gradeCategoryGuid,//大类标签唯一标识
    //   indicateName:detail.indicateName,//指标名称
    //   indicateType:detail.indicateType,//指标类型
    //   bizState:detail.bizState,//指标状态
    //   indicateDesc:detail.indicateDesc,//指标描述
    //   indicateWeight:detail.indicateWeight,//指标权重
    //   details:detail.details,//评级指标明细添加参数
      
    // };
    
   

    
    },
    // 指标权重校验
    indicateWeightCheck(val){
      if (val<1 ||val>100) {
        this.$message.error("指标权重为正数且≤100");
        this.configForm.indicateWeight=''
      }
    },
    // 分数校验
    scoreCheck(val,idx){
      if (val<0 ||val>100) {
        this.$message.error("分值≤100");
        this.configForm.details[idx].score=''
      }
    },
    // 添加打分标准
    addDetail(guid){
      if(!this.configForm.details){
        this.configForm.details=[]
      }
      let num=this.configForm.details.length +1
      let detail={
        orderNum:num,//排序号
        scoreContent:''	,//打分内容
        score:'',//分值
        isVote:'',//是否一票否决，Y是；N否
      }
      this.configForm.details.push(detail)
    },
    // 分页
    handleSizeChange(val) {
    let that = this;
    that.page.pageSize = val;
    this.search();
    },
    handleCurrentChange(val) {
      let that = this;
      that.page.pageIndex = val;
      this.search();
    },
  // 批量删除多选
  handleSelectionChange(val){
    let that=this
    that.guids=[]
    val.forEach((item,index)=>{
      that.guids.push(item.guid)
    })
    console.log('guids',guids);
    
  }
  
  },
};
</script>
<style lang="less" scoped>
.el-table /deep/ .el-input__inner {
height: 30px;
line-height: 40px;
}

.el-range-editor.el-input__inner {
padding: 0px;
}

/deep/ .el-checkbox__label {
display: none;
}
/deep/ .configure-fields {
    width: 800px !important;
  }
  /deep/ .configure-fields .el-dialog__body {
    overflow-y: auto;
    max-height: 600px;
  }
  /deep/ .el-dialog__footer {
    border-top: 1px solid #d9d9d9;
  }
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #d9d9d9;
  }
  .field-radio {
  display: flex;
  align-items: center;
}

.field-radio /deep/ .el-form-item__content {
  margin-left: 0 !important;
}
/deep/ .el-form-item {
  margin-bottom: 8px;
}
.attach-sty {
width: 170px;
float: left;
margin-top: 15px;
text-align: center;
}

.checkbox-img-sty {
border: 1px solid #dcdfe6;
width: 16px;
height: 16px;
border-radius: 2px;
cursor: pointer;
}

/deep/ .el-step__icon.is-text {
border-radius: 50%;
border-color: #4fa1a4;
border-color: inherit;
}

/deep/ .el-step__icon-inner {
color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
color: #4fa1a4;
}

// .content {
//   background: #fff;
//   font-size: 18px;
// }

.title {
text-align: left;
font-size: 16px;
font-weight: 600;
display: flex;
align-items: center;
margin-bottom: 10px;
}

.title span {
width: 6px;
height: 14px;
background: #4fa1a4;
display: inline-block;
margin-right: 10px;
}

.base {
background: #fff;
padding: 10px 0;
}

.content h1 {
margin: 4px 0px;
}

.base-content {
display: flex;
font-size: 15px;
padding: 7px 0;
}

.base-content .base-info {
display: flex;
align-items: center;
padding: 0 40px;
}

.base-content .base-info .base-title {
word-break: keep-all;
}

.button-area {
display: flex;
justify-content: space-between;
padding: 8px;
margin-top: 0;
}

/deep/.el-checkbox__label {
display: block;
}

.checkbox-show {
display: flex;
margin-bottom: 10px;
}
.field-show {
display: flex;
align-items: center;
height: 40px;
padding-left: 10px;
}

.product {
display: flex;
align-items: center;
}

.product-img {
width: 60px;
height: 40px;
margin-right: 15px;
}

.product-text {
width: 130px;
overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;
}

.el-col-5 {
 width: 33%;
}

.ipt-sty {
 width: 69% !important;
}
.add-btn{
 width: 80%;
 height:28px;
 line-height: 28px;
 margin-top: 8px;
 padding: 0;
}
.flex{
 width: 80%;
 margin: auto;
 display: flex;
 justify-content: space-between;
}
.flex1{
 display: flex;
 flex-direction: column;
 justify-content: space-between;
}

.checkTag{
 background-color:rgb(242, 242, 242) ;
}
.btn {
display: none;
}
.btn a {
cursor: pointer;
}
.el-table__body tr:hover .btn {
display: block;
}

/deep/.el-tree-node__label {
 width: 80%;
 white-space: normal;
 overflow: hidden;
 text-align: left;
}
//  /deep/.el-table td.el-table__cell div{
//     text-overflow: ellipsis;
//   }

.el-tree-node__content {
 height: auto;
}

.radio-ora {
 margin-right: 12px;
}

.staff-type {
 display: inline-block;
 width: 72px;
 height: 28px;
 line-height: 28px;
 color: #4FA1A4;
 background: rgba(234, 248, 248, 0.39);
 border-radius: 2px;
}

.staff-type-biz {
 display: inline-block;
 width: 52px;
 height: 28px;
 line-height: 28px;
 color: #4FA1A4;
 background: rgba(234, 248, 248, 0.39);
 border-radius: 2px;
}

.staff-wrap {
 color: #D8814B;
 background: rgba(255, 238, 224, 0.39);
}

.biz-state {
 display: inline-block;
 width: 48px;
 height: 21px;
 line-height: 21px;
 background: rgba(239, 239, 239, 0.38);
 border-radius: 11px;
 margin-left: 5px;
}

.select-node {
 margin: 0 0 17px 0;
 text-align: left;
 font-size: 18px;
 color: #323233;
}

.custom-tree-node {
 display: inline-flex;
 overflow: hidden;
}

.content-main-box {

 overflow-y: visible;
}


.search-area-div{
  flex-shrink: 0;
  margin-right: 4px
}
.ipt-sty{
  flex: 1;
}
.el-col-6{
  display: flex;
  justify-content: flex-end;
}
.el-col-12{
  display: flex;
  justify-content: flex-end;
}
.el-col-8{
  display: flex;
  // margin-bottom: 15px;
  justify-content: flex-end;
}
.content-pagination-box.el-pagination{
  left:240px
}
.left-tree-box {
  height: calc(100vh - 102px);
}
</style>
